import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TrackingPage from "@/pages/tracking/TrackingPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminForgotPassword from "@/pages/admin/AdminForgotPassword";
import AdminResetPassword from "@/pages/admin/AdminResetPassword";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AgentsPage from "@/pages/admin/AgentsPage";
import TeamPage from "@/pages/admin/TeamPage";
import ZonesPage from "@/pages/admin/ZonesPage";
import TransfersPage from "@/pages/admin/TransfersPage";
import WithdrawalsPage from "@/pages/admin/WithdrawalsPage";
import SettingsPage from "@/pages/admin/SettingsPage";
import AgentLogin from "@/pages/agent/AgentLogin";
import AgentDashboard from "@/pages/agent/AgentDashboard";
import ControlBoardPage from "@/pages/admin/ControlBoardPage";
import MesajePage from "@/pages/admin/MesajePage";
import AdminLayout from "@/layouts/AdminLayout";
import ProtectedRoute from "@/routes/ProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TrackingPage />} />
        <Route path="/agent" element={<AgentLogin />} />
        <Route path="/agent/dashboard" element={<AgentDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
        <Route path="/admin/reset-password" element={<AdminResetPassword />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="agents" element={<AgentsPage />} />
          <Route path="mesajes" element={<MesajePage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="zones" element={<ZonesPage />} />
          <Route path="transfers" element={<TransfersPage />} />
          <Route path="withdrawals" element={<WithdrawalsPage />} />
          <Route path="kontwol" element={<ControlBoardPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
